import { render } from "./Button.vue?vue&type=template&id=c31f92fe&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=c31f92fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c31f92fe"

export default script